import { Directive, HostListener, inject, Input } from '@angular/core';
import { SearchService } from '../services/search.service';

@Directive({
    selector: '[appSearch]',
})
export class SearchDirective {
    @Input() term!: string;
    private readonly searchService = inject(SearchService);

    @HostListener('click')
    onClick() {
        this.searchService.search$.next(null);
    }
}
